module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fragment', [_c('Transition', {
    attrs: {
      "name": "expand"
    }
  }, [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && _vm.unitIndex == 0),
      expression: "show && unitIndex == 0"
    }],
    key: 'secondary_header_' + _vm.unitIndex,
    staticStyle: {
      "border-top": "12px solid #fff"
    }
  }, [_c('th', {
    staticClass: "border-0",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark'),
    staticStyle: {
      "min-width": "150px",
      "max-width": "150px"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-nowrap',
    staticStyle: {
      "min-width": "150px",
      "max-width": "150px"
    }
  }, [_vm._v("Lot #")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Stackable")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Width")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Height")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center'
  }, [_vm._v("Hazard")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-left'
  }, [_vm._v("Contents")]), _vm._v(" "), _c('th', {
    class: (_vm.unit.expanded ? 'header-active' : 'header-dark') + ' text-center squeeze'
  })])]), _vm._v(" "), _c('Transition', {
    attrs: {
      "name": "expand"
    }
  }, [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    key: 'secondary_unit_' + _vm.unitIndex,
    staticClass: "bg-gray"
  }, [_c('td', {
    staticClass: "bg-white border-0",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.description),
      expression: "unit.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "sparse-text",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text",
      "id": 'r' + _vm.rowIndex + 'secondaryDesc' + _vm.unitIndex,
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "placeholder": "description..."
    },
    domProps: {
      "value": (_vm.unit.description)
    },
    on: {
      "keyup": _vm.productLiveSearch,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productrows && _vm.productrows.length > 0),
      expression: "productrows && productrows.length > 0"
    }],
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "id": 'r' + _vm.rowIndex + 'secondaryDesc' + _vm.unitIndex + 'auto'
    }
  }, [_vm._l((_vm.productrows), function(product, pIdx) {
    return [_c('div', {
      key: pIdx,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.productSelected(_vm.unit, product)
        }
      }
    }, [_vm._v(_vm._s(product.description))])]
  })], 2)]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.lot),
      expression: "unit.lot"
    }],
    staticClass: "sparse-text",
    attrs: {
      "type": "text",
      "id": 'r' + _vm.rowIndex + 'secondaryLot' + _vm.unitIndex,
      "autocapitalize": "off",
      "autocomplete": "off",
      "autocorrect": "off",
      "autofocus": "",
      "role": "combobox",
      "spellcheck": "false",
      "placeholder": "lot number...",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.unit.lot)
    },
    on: {
      "keyup": function($event) {
        return _vm.lotLiveSearch($event, _vm.unit)
      },
      "click": function($event) {
        return _vm.showLots($event, _vm.unit)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "lot", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lotRows.length > 0),
      expression: "lotRows.length > 0"
    }],
    staticClass: "customLiveSearch",
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "id": 'r' + _vm.rowIndex + 'secondaryLot' + _vm.unitIndex + 'auto'
    }
  }, [_vm._l((_vm.lotRows), function(lot, lIdx) {
    return [_c('div', {
      key: lIdx,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.lotSelected(_vm.unit, lot)
        }
      }
    }, [_vm._v(_vm._s(lot.name + ' (' + lot.available + ')'))])]
  })], 2)]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.quantity),
      expression: "unit.quantity"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.unit.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle",
    attrs: {
      "title": _vm.unit.type + ': ' + _vm.unit.apiIntegration + ' -- ' + _vm.unit.internalId
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.stackable),
      expression: "unit.stackable"
    }],
    staticClass: "form-control form-control-sm sparse-text",
    attrs: {
      "disabled": _vm.readOnly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "stackable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.unit.stackable) + "\n          "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.length),
      expression: "unit.length"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.unit.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "length", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.width),
      expression: "unit.width"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.unit.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "width", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.height),
      expression: "unit.height"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.unit.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "height", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.weight),
      expression: "unit.weight"
    }],
    staticClass: "sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly,
      "type": "text"
    },
    domProps: {
      "value": (_vm.unit.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unit, "weight", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center align-middle"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unit.hazardous),
      expression: "unit.hazardous"
    }],
    staticClass: "form-control form-control-sm sparse-text expander",
    attrs: {
      "disabled": _vm.readOnly
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unit, "hazardous", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('td', [_c('button', {
    class: 'btn btn-sm btn-block text-left text-nowrap ' + (_vm.unit.expanded ? 'btn-primary' : 'btn-secondary'),
    attrs: {
      "type": "button",
      "disabled": _vm.unit.type == 'None'
    },
    on: {
      "click": _vm.onUnitsExpand
    }
  }, [_c('span', {
    staticClass: "d-block"
  }, [_vm._v("\n                " + _vm._s(_vm.numPrimaryUnits || '---') + "\n                "), (_vm.unit.type != 'None') ? _c('span', {
    staticClass: "float-right"
  }, [_c('i', {
    class: _vm.unit.expanded ? 'fa fa-chevron-up spinEffect' : 'fa fa-chevron-down spinEffectReverse'
  })]) : _vm._e()])])]), _vm._v(" "), _c('td', {
    staticClass: "align-middle text-nowrap"
  }, [(!_vm.readOnly) ? _c('a', {
    staticClass: "text-body",
    on: {
      "click": _vm.cloneUnit
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-copy"
  })]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('a', {
    staticClass: "text-danger",
    on: {
      "click": _vm.removeUnit
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times"
  })]) : _vm._e()])])]), _vm._v(" "), _c('Transition', {
    attrs: {
      "name": "expand"
    }
  }, [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && _vm.unit.expanded),
      expression: "show && unit.expanded"
    }],
    attrs: {
      "transition": "expand"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "header-dark inset-primary-left-header"
  }, [_vm._v(_vm._s(_vm.unit.description))]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-nowrap"
  }, [_vm._v("Lot #")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Stackable")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Width")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Height")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center"
  }, [_vm._v("Hazard")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-left"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('th', {
    staticClass: "header-dark text-center squeeze"
  })])]), _vm._v(" "), _vm._l((this.unit.components), function(primary, primaryIndex) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show && _vm.unit.expanded),
        expression: "show && unit.expanded"
      }],
      key: 'primary_' + primaryIndex
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "inset-primary-left-body"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.description),
        expression: "primary.description"
      }],
      staticClass: "sparse-text",
      attrs: {
        "disabled": _vm.readOnly,
        "type": "text",
        "placeholder": "description...",
        "id": 'r' + _vm.rowIndex + 'secondaryDesc' + _vm.unitIndex + '-' + primaryIndex,
        "autocapitalize": "off",
        "autocomplete": "off",
        "autocorrect": "off",
        "autofocus": "",
        "role": "combobox",
        "spellcheck": "false"
      },
      domProps: {
        "value": (primary.description)
      },
      on: {
        "keyup": _vm.productLiveSearch,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "description", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.productrows && _vm.productrows.length),
        expression: "productrows && productrows.length"
      }],
      staticClass: "customLiveSearch",
      staticStyle: {
        "max-width": "240px"
      },
      attrs: {
        "id": 'r' + _vm.rowIndex + 'secondaryDesc' + _vm.unitIndex + '-' + primaryIndex + 'auto'
      }
    }, [_vm._l((_vm.productrows), function(product, pIdx) {
      return [_c('div', {
        key: pIdx,
        staticClass: "customLiveSearchElement",
        on: {
          "click": function($event) {
            return _vm.productSelected(primary, product)
          }
        }
      }, [_vm._v(_vm._s(product.description))])]
    })], 2)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.lot),
        expression: "primary.lot"
      }],
      staticClass: "sparse-text",
      attrs: {
        "type": "text",
        "placeholder": "lot number...",
        "id": 'r' + _vm.rowIndex + 'secondaryLot' + _vm.unitIndex + '-' + primaryIndex,
        "autocapitalize": "off",
        "autocomplete": "off",
        "autocorrect": "off",
        "autofocus": "",
        "role": "combobox",
        "spellcheck": "false",
        "disabled": _vm.readOnly
      },
      domProps: {
        "value": (primary.lot)
      },
      on: {
        "keyup": function($event) {
          return _vm.lotLiveSearch($event, primary)
        },
        "click": function($event) {
          return _vm.showLots($event, primary)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "lot", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.lotRows.length > 0),
        expression: "lotRows.length > 0"
      }],
      staticClass: "customLiveSearch",
      staticStyle: {
        "max-width": "240px"
      },
      attrs: {
        "id": 'r' + _vm.rowIndex + 'secondaryLot' + _vm.unitIndex + '-' + primaryIndex + 'auto'
      }
    }, [_vm._l((_vm.lotRows), function(lot, lIdx) {
      return [_c('div', {
        key: lIdx,
        staticClass: "customLiveSearchElement",
        on: {
          "click": function($event) {
            return _vm.lotSelected(primary, lot)
          }
        }
      }, [_vm._v(_vm._s(lot.name + ' (' + lot.available + ')'))])]
    })], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.quantity),
        expression: "primary.quantity"
      }],
      staticClass: "sparse-text expander",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "disabled": _vm.readOnly,
        "type": "text"
      },
      domProps: {
        "value": (primary.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "quantity", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.stackable),
        expression: "primary.stackable"
      }],
      staticClass: "form-control form-control-sm sparse-text expander",
      staticStyle: {
        "min-width": "68px"
      },
      attrs: {
        "disabled": _vm.readOnly
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(primary, "stackable", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Yes")]), _vm._v(" "), _c('option', [_vm._v("No")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.length),
        expression: "primary.length"
      }],
      staticClass: "sparse-text expander",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "disabled": _vm.readOnly,
        "type": "text"
      },
      domProps: {
        "value": (primary.length)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "length", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.width),
        expression: "primary.width"
      }],
      staticClass: "sparse-text expander",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "disabled": _vm.readOnly,
        "type": "text"
      },
      domProps: {
        "value": (primary.width)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "width", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.height),
        expression: "primary.height"
      }],
      staticClass: "sparse-text expander",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "disabled": _vm.readOnly,
        "type": "text"
      },
      domProps: {
        "value": (primary.height)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "height", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.weight),
        expression: "primary.weight"
      }],
      staticClass: "sparse-text expander",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "disabled": _vm.readOnly,
        "type": "text"
      },
      domProps: {
        "value": (primary.weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(primary, "weight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (primary.hazardous),
        expression: "primary.hazardous"
      }],
      staticClass: "form-control form-control-sm sparse-text expander",
      staticStyle: {
        "min-width": "68px"
      },
      attrs: {
        "disabled": _vm.readOnly
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(primary, "hazardous", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Yes")]), _vm._v(" "), _c('option', {
      attrs: {
        "selected": "selected"
      }
    }, [_vm._v("No")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-left text-nowrap"
    }, [_c('button', {
      staticClass: "btn btn-sm text-left text-nowrap btn-secondary",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "button",
        "disabled": ""
      }
    }, [_c('span', {
      staticClass: "d-block"
    }, [_vm._v("\n                " + _vm._s((primary.quantity * (primary.unitsPerCase || 1)) || '---') + "\n            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle text-nowrap"
    }, [(!_vm.readOnly) ? _c('a', {
      staticClass: "text-body",
      on: {
        "click": function($event) {
          return _vm.duplicatePrimary(primary, primaryIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-copy"
    })]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          return _vm.removePrimary(primaryIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-times"
    })]) : _vm._e()])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && _vm.unit.expanded && !_vm.readOnly),
      expression: "show && unit.expanded && !readOnly"
    }]
  }, [_c('td', {
    staticClass: "bg-white border-0",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-right inset-primary-left-body",
    staticStyle: {
      "border-bottom": "12px solid rgba(248,248,248,1)"
    },
    attrs: {
      "colspan": "11"
    }
  }, [_c('button', {
    staticClass: "btn btn-clear",
    on: {
      "click": _vm.addPrimaryUnit
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" ADD ROW")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497ed506"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shippinglvls/SecondaryRow.vue
// module id = 705
// module chunks = 0